import React from "react";
import { ID } from "common/entities/IEntity";
import * as contributorFragments from "../article/contributorFragments";
import { FragmentLayout } from "../../../core/components/FragmentLayout";
import * as commonFragments from "../article/commonFragments";
import * as contributorCardFragments from "../article/contributorCardFragments";
import * as itemContainerFragments from "../article/itemContainerFragments";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as parentContainerFragments from "../article/parentContainerFragment";

const ItemFragments = FragmentProvider.forFragments(
	"contributor-item",
	itemContainerFragments
);
const ContainerFragments = FragmentProvider.forFragments(
	"contributor-container",
	parentContainerFragments
);
interface IArticleContributorListProps {
	article: ID;
	config: any;
}
export function ArticleContributorList(props: IArticleContributorListProps) {
	const renderItem = (item: any, index: number) => {
		return (
			<ItemFragments
				fragments={props.config.itemFragment}
				fragmentProps={{
					key: "contributor:" + index,
					articleContributor: item,
				}}
			>
				<FragmentLayout
					layout={props.config.contributorCardLayout}
					fragments={{ ...contributorCardFragments }}
					props={{ articleContributor: item }}
				/>
			</ItemFragments>
		);
	};

	return (
		<React.Fragment>
			<FragmentLayout
				layout={props.config.contributorLayout}
				fragments={{ ...commonFragments, ...contributorFragments }}
				props={{
					article: props.article,
					articleContributor: props.article.contributors,
				}}
			/>

			<ContainerFragments
				fragments={props.config.containerFragment}
				fragmentProps={{
					articleContributor: props.article.contributors,
					renderItem: renderItem,
				}}
			>
				{(props.article.contributors &&
					props.article.contributors.length &&
					props.article.contributors.map((item, index) => {
						return (
							<ItemFragments
								fragments={props.config.itemFragment}
								fragmentProps={{
									key: "contributor:" + index,
									articleContributor: item,
								}}
							>
								<FragmentLayout
									layout={props.config.contributorCardLayout}
									fragments={{ ...contributorCardFragments }}
									props={{ articleContributor: item }}
								/>
							</ItemFragments>
						);
					})) ||
					""}
			</ContainerFragments>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/articleContributor/ArticleContributorList.tsx